// extracted by mini-css-extract-plugin
module.exports = {"withLoader":"Image_withLoader___IeSA","loader":"Image_loader__d_Pxc","image":"Image_image__1H4C3"};